import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useState } from "react";
import PlanAndDetailsContent from "./PlanAndDetailsContent";
import { COLORS } from "../../../../styles/theme";
import {
  updateRegressionPlan_API,
  executeRegressionPlan_API,
} from "../../../../api/controller/RegressionController";
import { useTheme } from "@mui/material/styles";

import { useApplicationContext } from "../../../../context/ApplicationContext";
import { Severity } from "../../../../constant/ApplicationVariables";

export default function TestSuiteCreate({
  onCancel,
  onPlanCreated,
  initialSuite,
}) {
  const [tab, setTab] = useState(0);
  const { handleSnackbar, activeProject } = useApplicationContext();
  const theme = useTheme();

  // Form data from child
  const [planPayload, setPlanPayload] = useState({
    testCases: initialSuite?.testCases || [],
  });

  const [planCreated, setPlanCreated] = useState(false);

  const handleUpdate = async () => {
    if (!planPayload?.testCases || planPayload.testCases.length === 0) {
      handleSnackbar("Please select at least one test case", Severity.warning);
      return;
    }

    try {
      // Start with existing test cases
      // const existingTCs = initialSuite.testCases || [];

      // New test cases from the form
      const newTCs = planPayload.testCases;

      // Append new test cases to existing ones, avoiding duplicates
      // const mergedTCs = [
      //   ...existingTCs,
      //   ...newTCs.filter(
      //     (tc) =>
      //       !existingTCs.some(
      //         (et) =>
      //           (et.testCaseCustomId || et.customId) ===
      //           (tc.testCaseCustomId || tc.customId)
      //       )
      //   ),
      // ];

      // Prepare API payload
      const payload = {
        name: initialSuite.name,
        projectName: activeProject.name,
        testCases: newTCs.map((tc) => ({
          testCaseCustomId: tc.testCaseCustomId || tc.customId,
          folderPath: tc.folderPath,
          elementFileId:
            tc.selectedFiles?.ELEMENT?.fileId || tc.elementFile?.fileId || null,
          applicationFileId:
            tc.selectedFiles?.APPLICATION?.fileId ||
            tc.applicationFile?.fileId ||
            null,
          testDataFileId:
            tc.selectedFiles?.TESTDATA?.fileId ||
            tc.testDataFile?.fileId ||
            null,
          scriptFileId:
            tc.selectedFiles?.SCRIPT?.fileId || tc.scriptFile?.fileId || null,
        })),
        lastModifiedAt: initialSuite.lastModifiedAt,
      };

      await updateRegressionPlan_API(payload);
      handleSnackbar("Test cases updated successfully!", Severity.success);

      onPlanCreated?.(payload); // refresh the list
    } catch (err) {
      console.error(err);
      handleSnackbar("Failed to update test cases", Severity.error);
    }
  };

  return (
    <Box height="100vh" display="flex" flexDirection="column">
      {/* ───────── Header ───────── */}
      <Box
        bgcolor="background.paper"
        py={1}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box className="flex items-center gap-2">
            {/* Back Arrow Button */}
            <Button
              className="cursor-pointer p-1 rounded"
              onClick={onCancel} // navigate back
              sx={{
                backgroundColor: "transparent",
                "&:hover": { opacity: 0.8 },
              }}
            >
              <ArrowBackIcon
                fontSize="small"
                sx={{ color: theme.palette.primary.main }}
              />
              <Typography fontWeight={600} color={theme.palette.text.primary}>
                Back
              </Typography>
            </Button>

            {/* Header Text */}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",

              backgroundColor: (theme) => theme.palette.highlight.light,
              borderRadius: 1,
            }}
          >
            <Typography variant="subtitle1" fontWeight={600} fontSize="1rem">
              {initialSuite?.name || "Plan & Details"}
            </Typography>
          </Box>

          <Box display="flex" gap={1}>
            <Button onClick={onCancel}>Cancel</Button>
          <Button
  onClick={handleUpdate}
  sx={{
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: 600,
    height: 40,
    px: 3,
    background: "linear-gradient(90deg, hsl(var(--cyan)), hsl(var(--emerald)))",
    color: "hsl(var(--primary-foreground))",
    boxShadow: "0 4px 14px hsl(var(--cyan) / 0.35)",
    "&:hover": {
      background: "linear-gradient(90deg, hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9))",
      boxShadow: "0 6px 20px hsl(var(--cyan) / 0.45)",
    },
    "&:active": {
      transform: "scale(0.98)",
    },
  }}
>
  Add
</Button>


          </Box>
        </Box>
      </Box>

      {/* ───────── Content ───────── */}
      {tab === 0 && (
        <PlanAndDetailsContent
          plan={initialSuite}
          onChange={setPlanPayload}
          onAddTestCases={(updatedTCs) =>
            setPlanPayload({ testCases: updatedTCs })
          }
          onRemoveTestCase={(tcId, updatedTestCases) => {
            setPlanPayload((prev) => ({
              ...prev,
              testCases: updatedTestCases,
            }));
          }}
        />
      )}
    </Box>
  );
}
